<template>

<core-modal v-on:close="onClose" type="confirm">

	<template v-slot:head>

		Leave Group

	</template>

	<template v-slot:default>

		<p>Are you sure you wish to leave this group?</p>

		<div class="notice">It may take some time to leave the group, especially if the group has a speedboost that needs re-indexing.</div>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading">Yes</core-button>
		<core-button theme="plain" v-on:click.native="onClose">No</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

			this.$store.dispatch('api/groups/leave', {
				name: this.$route.params.name
			}).then(function() {

				window.location.reload()

			}, function() {

				this.is.loading = false

			}.bind(this)) 

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.notice {
	padding: 10px;
	border-radius: 4px;
	color: #fff;
	font-size: 16px;
	line-height: 20px;
	background-color: #4881bb;
	font-weight: 400;
}

.notice:after {
	content: '';
    display: block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 16px 16px 16px;
    border-color: transparent transparent #4881bb  transparent;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    position: absolute;
    left: 17px;
    top: -10px;
}

</style>